import React from 'react'

const SectionHeader = props => (
    <div className="content-header">
        { props.children }
    </div>
)

export default SectionHeader